"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "CustomColorPicker", {
    enumerable: true,
    get: function() {
        return CustomColorPicker;
    }
});
var _react = /*#__PURE__*/ _interopRequireDefault(require("react"));
var _reactColor = require("react-color");
var _common = require("react-color/lib/components/common");
var _reactcss = /*#__PURE__*/ _interopRequireDefault(require("reactcss"));
var _input = require("../Input");
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _extends() {
    _extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source){
                if (Object.prototype.hasOwnProperty.call(source, key)) {
                    target[key] = source[key];
                }
            }
        }
        return target;
    };
    return _extends.apply(this, arguments);
}
function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _objectSpreadProps(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
var styles = (0, _reactcss.default)({
    default: {
        pointer: {
            boxShadow: "0px 0px 0px 1px rgb(0 0 0 / 10%) inset, 0px 0px 0px 1px hsl(0deg 0% 90%)"
        },
        colorGradient: {
            height: "232px"
        },
        hexInput: {
            width: "102px",
            height: "38px"
        },
        rgbInput: {
            width: "50px",
            height: "38px"
        }
    }
});
var HueCustomPointer = function() {
    return /*#__PURE__*/ _react.default.createElement("div", {
        className: "border border-white w-2.5 h-2.5 mt-px rounded-lg",
        style: styles.pointer
    });
};
var SatCustomPointer = function() {
    return /*#__PURE__*/ _react.default.createElement("div", {
        className: "border border-white w-3.5 h-3.5 rounded-lg",
        style: styles.pointer
    });
};
var CustomColorPicker = (0, _reactColor.CustomPicker)(function(props) {
    var onChange = props.onChange, hex = props.hex, _props_color = props.color, r = _props_color.r, g = _props_color.g, b = _props_color.b;
    var handleChangeHex = function(ev) {
        var value = ev.target.value;
        var rawHex = value.substring(1);
        var updatedHex = ("000000" + rawHex).slice(-6);
        onChange({
            hex: "#".concat(updatedHex)
        });
    };
    var handleChangeRGB = function(ev) {
        var _ev_target = ev.target, value = _ev_target.value, name = _ev_target.name;
        var rgbValue = value ? value : "0";
        var curValue = {
            r: r,
            g: g,
            b: b
        };
        onChange(_objectSpreadProps(_objectSpread({}, curValue), _defineProperty({}, name, parseInt(rgbValue))));
    };
    return /*#__PURE__*/ _react.default.createElement("div", {
        className: "p-3 rounded-lg shadow-lg border border-gray-300 box-border bg-white"
    }, /*#__PURE__*/ _react.default.createElement("div", {
        className: "relative w-72 overflow-hidden rounded-md m-auto border border-black border-opacity-10 box-border",
        style: styles.colorGradient
    }, /*#__PURE__*/ _react.default.createElement(_common.Saturation, _extends({}, props, {
        pointer: SatCustomPointer
    }))), /*#__PURE__*/ _react.default.createElement("div", {
        className: "relative h-3 overflow-hidden rounded-3xl m-auto mt-3 box-border bg-[#f00]"
    }, /*#__PURE__*/ _react.default.createElement(_common.Hue, _extends({}, props, {
        pointer: HueCustomPointer,
        direction: "horizontal"
    }))), /*#__PURE__*/ _react.default.createElement("div", {
        className: "flex w-72 mt-3 box-border"
    }, /*#__PURE__*/ _react.default.createElement(_input.InputGroup, {
        label: "Hex"
    }, /*#__PURE__*/ _react.default.createElement(_input.Input, {
        style: styles.hexInput,
        id: "hex",
        name: "hex",
        type: "text",
        "data-testid": "hex",
        value: hex,
        onChange: handleChangeHex
    })), /*#__PURE__*/ _react.default.createElement(_input.InputGroup, {
        className: "ml-3",
        label: "R"
    }, /*#__PURE__*/ _react.default.createElement(_input.Input, {
        style: styles.rgbInput,
        id: "r",
        name: "r",
        type: "text",
        "data-testid": "r",
        value: r,
        onChange: handleChangeRGB
    })), /*#__PURE__*/ _react.default.createElement(_input.InputGroup, {
        className: "ml-2",
        label: "G"
    }, /*#__PURE__*/ _react.default.createElement(_input.Input, {
        style: styles.rgbInput,
        id: "g",
        name: "g",
        type: "text",
        "data-testid": "g",
        value: g,
        onChange: handleChangeRGB
    })), /*#__PURE__*/ _react.default.createElement(_input.InputGroup, {
        className: "ml-2",
        label: "B"
    }, /*#__PURE__*/ _react.default.createElement(_input.Input, {
        style: styles.rgbInput,
        id: "b",
        name: "b",
        type: "text",
        "data-testid": "b",
        value: b,
        onChange: handleChangeRGB
    }))));
});

//# sourceMappingURL=CustomColorPicker.js.map